import styles from'./collapseSettingComp.module.sass'
import cn from "classnames";
import React, {useState} from "react";

export const CollapseSettingComp = ({children, name, type}: any) => {

    const [hidden, setHidden] = useState(true)

    return (
        <div className={cn(styles.main, hidden ? styles.hidden : styles.expanded)}
             onMouseEnter={() => setHidden(false)}
             onMouseLeave={() => setHidden(true)}>
            {hidden ? `${type} по полю ${name}` : children}
        </div>
    );
};

